import { render, staticRenderFns } from "./rule-detail.vue?vue&type=template&id=c9b63c04&scoped=true"
import script from "./rule-detail.vue?vue&type=script&lang=js"
export * from "./rule-detail.vue?vue&type=script&lang=js"
import style0 from "./rule-detail.vue?vue&type=style&index=0&id=c9b63c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b63c04",
  null
  
)

export default component.exports